import { create } from 'zustand';

interface DailyScrumModalState {
    isOpen: boolean;
    teamId: string | undefined;
    selectedDate: Date;

    openModal: ({
        teamId,
        selectedDate,
    }: {
        teamId: string;
        selectedDate: Date;
    }) => void;
    closeModal: () => void;
}

const useDailyScrumModalStore = create<DailyScrumModalState>(set => ({
    isOpen: false,
    teamId: undefined,
    selectedDate: new Date(),
    openModal: ({
        teamId,
        selectedDate,
    }: {
        teamId: string;
        selectedDate: Date;
    }) => set({ isOpen: true, teamId, selectedDate }),
    closeModal: () => set({ isOpen: false }),
}));

export default useDailyScrumModalStore;
